// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionMap, ITraduccionMapKeys, TraduccionMap} from "services-translation/modules/base/traduccion/map";

import idiomas from "./_idiomas";

export interface ITraduccionCmpInsistWindowPlatformActionSecondaryKeys extends ITraduccionMapKeys {
    "app": string;
    "web": string;
}

export class TraduccionCmpInsistWindowPlatformActionSecondary extends TraduccionMap {
    /* STATIC */
    protected static override readonly ID: string = "cmp.insist_window.platform_action_secondary";
    private static VALUES?: ITraduccionMap;

    public static override build(lang: IIdioma): TraduccionCmpInsistWindowPlatformActionSecondary {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": {
                    "valores": {
                        "app": "",
                        "web": "Ja estàs regustrat? Inicia sessió"
                    }
                },
                "cs": {
                    "valores": {
                        "app": "",
                        "web": "Již jste se zaregistrovali? Přihlaste se"
                    }
                },
                "da": {
                    "valores": {
                        "app": "",
                        "web": "Er du allerede registreret? Log ind"
                    }
                },
                "de": {
                    "valores": {
                        "app": "",
                        "web": "Sie sind bereits registriert? Einloggen"
                    }
                },
                "en": {
                    "valores": {
                        "app": "",
                        "web": "Already registered? Sign in"
                    }
                },
                "es": {
                    "valores": {
                        "app": "",
                        "web": "¿Ya estás registrado? Inicia sesión"
                    }
                },
                "eu": {
                    "valores": {
                        "app": "",
                        "web": "Izena emanda al zaude dagoeneko? Saioa hasi"
                    }
                },
                "fi": {
                    "valores": {
                        "app": "",
                        "web": "Oletko jo rekisteröitynyt? Kirjaudu sisään"
                    }
                },
                "fr": {
                    "valores": {
                        "app": "",
                        "web": "Déjà inscrit ? S'identifier"
                    }
                },
                "gl": {
                    "valores": {
                        "app": "",
                        "web": "Xa estás rexistrado? Acceder"
                    }
                },
                "hi": {
                    "valores": {
                        "app": "",
                        "web": "पहले से ही पंजीकृत? दाखिल करना"
                    }
                },
                "hu": {
                    "valores": {
                        "app": "",
                        "web": "Már regisztrált? Jelentkezzen be"
                    }
                },
                "it": {
                    "valores": {
                        "app": "",
                        "web": "Già sei registrato? Accedi"
                    }
                },
                "nl": {
                    "valores": {
                        "app": "",
                        "web": "Bent u geregistreerd? Begin uw sessie"
                    }
                },
                "no": {
                    "valores": {
                        "app": "",
                        "web": "Er du allerede registrert? Logg inn"
                    }
                },
                "pl": {
                    "valores": {
                        "app": "",
                        "web": "Jesteś już zarejestrowany? Zaloguj się"
                    }
                },
                "pt": {
                    "valores": {
                        "app": "",
                        "web": "Já está registado? Inicie sessão"
                    }
                },
                "pt-BR": {
                    "valores": {
                        "app": "",
                        "web": "Você já está cadastrado? Cadastre-se"
                    }
                },
                "ro": {
                    "valores": {
                        "app": "",
                        "web": "V-ați înregistrat deja? Conectați-vă"
                    }
                },
                "ru": {
                    "valores": {
                        "app": "",
                        "web": "Вы уже зарегистрированы? Авторизируйтесь"
                    }
                },
                "sk": {
                    "valores": {
                        "app": "",
                        "web": "Už ste sa zaregistrovali? Prihláste sa"
                    }
                },
                "sv": {
                    "valores": {
                        "app": "",
                        "web": "Redan registrerad? Logga in"
                    }
                },
                "tr": {
                    "valores": {
                        "app": "",
                        "web": "Zaten kayıtlı mısınız? Oturum açın"
                    }
                }
            },
            "defecto": {
                "valores": {
                    "app": "",
                    "web": "Already registered? Log in"
                }
            }
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
